export const coreRoutes=[
    {
        path:'/currency',
        name:'currency',
        meta:{
            keepAlive:true
        },
        children:[
            {
                path: "authority",
                name: "authority",
                component: () => import("@/view/core/common/sys/AuthorityView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "assembly",
                name: "assembly",
                component: () => import("@/view/core/common/sys/AssemblyView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "subordinate",
                name: "subordinate",
                component: () => import("@/view/core/common/user/SubordinateView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "subaccount",
                name: "subaccount",
                component: () => import("@/view/core/common/user/SubaccountView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "personal",
                name: "personal",
                component: () => import("@/view/core/common/sys/PersonalView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "organization",
                name: "organization",
                component: () => import("@/view/core/common/sys/OrganizationView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "candidate",
                name: "candidate",
                component: () => import("@/view/core/common/sys/CandidateView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "management",
                name: "management",
                component: () => import("@/view/core/common/sys/ManagementView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "candidatechange",
                name: "candidatechange",
                component: () => import("@/view/core/common/sys/CandidateChangeView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "custominfo",
                name: "custominfo",
                component: () => import("@/view/core/common/sys/CustomerInfoView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "merchant",
                name: "merchant",
                component: () => import("@/view/core/common/sys/MerchantView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "cusplatform",
                name: "cusplatform",
                component: () => import("@/view/core/common/sys/CusPlatformView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "character",
                name: "character",
                component: () => import("@/view/core/common/sys/CharacterView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "subcharacter",
                name: "subcharacter",
                component: () => import("@/view/core/common/sys/SubcharacterView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "stagemanage",
                name: "stagemanage",
                component: () => import("@/view/core/common/sys/StageManage.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "noticemanage",
                name: "noticemanage",
                component: () => import("@/view/core/common/sys/NoticeManage.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "noticecategory",
                name: "noticecategory",
                component: () => import("@/view/core/common/sys/NoticeCategory.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "guidemanage",
                name: "guidemanage",
                component: () => import("@/view/core/common/sys/GuideManage.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "guidecategory",
                name: "guidecategory",
                component: () => import("@/view/core/common/sys/GuideCategory.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "systemconfig",
                name: "config",
                component: () => import("@/view/core/common/sys/SystemConfig.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "password",
                name: "password",
                component: () => import("@/view/core/common/sys/ChangePassword.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
            {
                path: "account",
                name: "account",
                component: () => import("@/view/system/AccountView.vue"),
                meta: {
                    keepAlive: true,
                    hasNav: true,
                },
            },
        ]
    }
]